
export default "/assets/table-cells-micro.56c2c34d.svg"